/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does the table work outside GitHub?`)
};

const es_mt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Funciona la tabla fuera de GitHub?`)
};

const de_mt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioniert die Tabelle auch außerhalb von GitHub?`)
};

const nl_mt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkt de tabel buiten GitHub?`)
};

const fr_mt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tableau fonctionne-t-il en dehors de GitHub ?`)
};

const it_mt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tabella funziona al di fuori di GitHub?`)
};

const pt_br2_mt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tabela funciona fora do GitHub?`)
};

const pt_mt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tabela funciona fora do GitHub?`)
};

const ja_mt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーブルは GitHub 外で機能しますか？`)
};

const zh_mt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个表格在 GitHub 之外也能用吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_faq4_q", locale)
	if (locale === "en") return en_mt_faq4_q(inputs)
	if (locale === "es") return es_mt_faq4_q(inputs)
	if (locale === "de") return de_mt_faq4_q(inputs)
	if (locale === "nl") return nl_mt_faq4_q(inputs)
	if (locale === "fr") return fr_mt_faq4_q(inputs)
	if (locale === "it") return it_mt_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_mt_faq4_q(inputs)
	if (locale === "pt") return pt_mt_faq4_q(inputs)
	if (locale === "ja") return ja_mt_faq4_q(inputs)
	return zh_mt_faq4_q(inputs)
};